import { z } from "zod";

export const authVerifyMfaOtpInputZodSchema = z.object({
	code: z
		.string()
		.length(6, "認証コードは6文字で入力してください")
		.regex(/^\d{6}$/, "認証コードは半角数字6桁で入力してください"),
});

export type AuthVerifyMfaOtpInputType = z.infer<typeof authVerifyMfaOtpInputZodSchema>;
